import { createFileRoute } from '@tanstack/react-router';
import { DepositAccountTransactions } from '@/features/portal/deposit-accounts/account/transactions/Transactions.tsx';

export const Route = createFileRoute(
  '/portal/deposit-account/$depositAccountId/home/transactions',
)({
  head: () => ({ meta: [{ title: 'Transactions' }] }),
  component: DepositAccountTransactions,
});
